import { render } from "./ModalAffiliatesUserElement.vue?vue&type=template&id=2139219f&scoped=true"
import script from "./ModalAffiliatesUserElement.vue?vue&type=script&lang=js"
export * from "./ModalAffiliatesUserElement.vue?vue&type=script&lang=js"

import "./ModalAffiliatesUserElement.vue?vue&type=style&index=0&id=2139219f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2139219f"]])

export default __exports__